import { ReactNode } from "react";
import { Box, Typography, alpha } from "@mui/material";
import { CardCore } from "src/Pages/components/CardCore/CardCore";

interface IMetricCard {
  title: string;
  value: string;
  subtitle?: string;
  color?: string;
  icon?: ReactNode;
  compact?: boolean;
  withBorderLeft?: boolean;
}

export const MetricCard = ({
  title,
  value,
  subtitle,
  color = "#1976d2",
  icon,
  compact = false,
  withBorderLeft = true,
}: IMetricCard) => {
  return (
    <CardCore
      sxStyle={{
        margin: 0,
        p: compact ? 1.5 : 2,
        borderRadius: "12px",
        borderLeft: withBorderLeft ? `3px solid ${color}` : "",
      }}
    >
      <Box sx={{ display: "flex", alignItems: "center", justifyContent: "space-between" }}>
        <Typography variant="caption" sx={{ color: "text.secondary", fontWeight: 600 }}>
          {title}
        </Typography>
        {icon && (
          <Box
            sx={{
              width: 24,
              height: 24,
              borderRadius: "50%",
              display: "grid",
              placeItems: "center",
              color,
              backgroundColor: alpha(color, 0.12),
            }}
          >
            {icon}
          </Box>
        )}
      </Box>
      <Typography
        sx={{
          mt: 0.8,
          color,
          fontWeight: 800,
          fontSize: compact ? "1.5rem" : "1.1rem",
        }}
      >
        {value}
      </Typography>
      {subtitle && (
        <Typography variant="caption" sx={{ color: "text.secondary" }}>
          {subtitle}
        </Typography>
      )}
    </CardCore>
  );
};
